import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { numberToCurrency } from "helpers/string"
import { useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import StatCard from "./StatCard"
import { getDateLabel } from "./utils/dateLabels"

Profit.propTypes = {
  params: PropTypes.shape({
    overview_range: PropTypes.string.isRequired,
    date_gteq: PropTypes.string,
    date_lteq: PropTypes.string
  }).isRequired
}

export default function Profit({ params }) {
  const { t } = useTranslation()
  const { profit_stats, date_range } = useSelector(metadataSelector("accounting"))
  const dates = getDateLabel(params, date_range?.label)

  return (
    <StatCard
      title={t("accounting.labels.profit")}
      tooltip={t("accounting.labels.profit_tooltip", { dates })}
      dates={dates}
      value={numberToCurrency(profit_stats[params.overview_range])}
      monthlyDiff={profit_stats.monthly_diff}
      isCurrentMonth={params.overview_range === "current_month"}
    />
  )
}
